// extracted by mini-css-extract-plugin
module.exports = {"Logo":"_2kHbHSiBr15rgS55u0LnPE"};